import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<VelvetTag @variant={{this.variant}}>\n  {{yield}}\n</VelvetTag>",{ moduleName: "walden-fast/components/client-tag/index.hbs" })